<template>
    <span class="contrasena" @click="copiarAlPortapapeles" :style="estilo" ref="valor">
        {{valor}}
    </span>
</template>

<script>
export default {
  name: "CajaContrasena",
  props: {
     valor: String
  },
  data: function() {
    return {
      estilo: ""
    };
  },
  methods: {
    setClipboard: function(value) {
      var tempInput = document.createElement("input");
      tempInput.style = "position: absolute; left: -1000px; top: -1000px";
      tempInput.value = value;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
    },
    copiarAlPortapapeles: function() {
      this.setClipboard(this.valor);
      this.estilo = null;
      setTimeout(() => this.estilo = "animation-name: example; animation-duration: 1s;", 10);
    }
  }
};
</script>

<style>
.contrasena {
  font-family: monospace;
  font-size: 14pt;
  font-weight: bold;
}
@keyframes example {
  0%   {font-size: 14pt;}
  15%  {font-size: 16pt; color: limegreen;}
  75%  {font-size: 16pt; color: green;}
  100% {font-size: 14pt;}
}
</style>
